import React from 'react';
import SeminarWorkLongtermEvaluation from './SeminarWorkLongtermEvaluation';

function DialogSeminarWorkLongtermEvaluation() {
    return <SeminarWorkLongtermEvaluation />;
}

export default DialogSeminarWorkLongtermEvaluation;
